/**
 * 用于管理localstorage数据
 */

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var util = require('./util');
var localstorage = require('./localstorage');

(function () {

    // 缓存数据 存入时间点 参数名
    var TIMESTAMP_KEY = '__timestamp';
    // 缓存数据 存入版本 参数名
    var VERSION_KEY = '__version';
    // 缓存数据 参数 参数名
    var LOC_PARAMS_KEY = '__params';
    // 缓存数据 Key 参数名
    var KEY_KEY = '__key';
    // 缓存数据 缓存标志 参数名
    var IS_LOC_DATA_KEY = '__isLocData';

    /**
     * @class LocDataManager
     * @constructor
     * @param cfg            {Object} 必选，配置项
     * @param cfg.key        {String} 必选，LocalStorage Key
     * @param cfg.expirtTime {Number} LocalStorage 数据过期时间，单位秒，默认: 86400，一天
     * @param cfg.version    {String} 项目版本号
     */
    var LocDataManager = function LocDataManager(cfg) {
        var t = this;

        cfg = cfg || {};

        // 初始化参数
        t.key = cfg.key;
        t.expirtTime = cfg.expirtTime || 86400;
        t.version = cfg.version;
        t.params = cfg.params || {};
    };

    util.mix(LocDataManager.prototype, {
        /**
         * 存储数据至 LocalStorage，存数据方法只存入当前时间戳，不存入过期时间
         * @public
         * @param  cfg         {Object}  必选，配置项
         * @param  cfg.key     {String}  必选，LocalStorage Key
         * @param  cfg.data    {*}       必选，需要存储的数据
         * @param  cfg.params  {Object}  需要存储的参数
         * @param  cfg.version {String}  项目版本号
         * @return             {Boolean} 是否存储成功
         */
        set: function set(cfg) {
            var t = this;

            cfg = cfg || {};

            // 初始化参数
            var key = cfg.key || this.key;
            var version = cfg.version || this.version;
            var data = _typeof(cfg.data) == 'object' ? util.merge(cfg.data) : util.merge({
                data: cfg.data
            });

            if (!key) {
                return false;
            }

            // 注入时间戳、版本、Key、缓存标志至存储的数据中
            data[TIMESTAMP_KEY] = new Date().getTime();
            data[VERSION_KEY] = version;
            data[KEY_KEY] = key;
            data[IS_LOC_DATA_KEY] = true;

            var params = util.merge(t.params, cfg.params);

            if (params) {
                data[LOC_PARAMS_KEY] = cfg.params;
            }

            localstorage.set(key, JSON.stringify(data));

            return true;
        },

        /**
         * 从 LocalStorage 中取数据，过期时间由取数据方法控制
         * @public
         * @param  cfg            {Object} 必选，配置项
         * @param  cfg.key        {String} 必选，LocalStorage Key
         * @param  cfg.expirtTime {Number} LocalStorage 数据过期时间，单位秒，默认: 86400，一天
         * @param  cfg.version    {String} 项目版本号
         * @return                {Object} 缓存数据
         */
        get: function get(cfg) {
            var t = this;

            cfg = cfg || {};

            // 初始化参数
            var key = cfg.key || t.key;
            var expirtTime = cfg.expirtTime || t.expirtTime;
            var version = cfg.version || t.version;

            if (!key) {
                return false;
            }

            var data;
            try {
                data = JSON.parse(localstorage.get(key));
            } catch (e) {
                console.log(e);
                return false;
            }

            if (!data || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) != 'object' || !data[TIMESTAMP_KEY] || new Date().getTime() - data[TIMESTAMP_KEY] >= expirtTime * 1000 || data[VERSION_KEY] != version) {

                t.remove({
                    key: key
                });

                return false;
            }

            return data;
        },

        /**
         * 从 LocalStorage 中清除数据
         * @public
         * @param  cfg     {Object}  必选，配置项
         * @param  cfg.key {String}  必选，LocalStorage Key
         * @return         {Boolean} 是否清除成功
         */
        remove: function remove(cfg) {
            var t = this;

            cfg = cfg || {};

            var key = typeof cfg == 'string' ? cfg : cfg.key || t.key;

            if (!key) {
                return false;
            }

            localstorage.remove(key);

            return true;
        }
    });

    module.exports = LocDataManager;
})();


/*****************
 ** WEBPACK FOOTER
 ** ./components/pipe/util/loc-data-manager.js
 ** module id = 12
 ** module chunks = 0
 **/